import { openModal } from '@core/components/ModalStack';
import { WidgetLibraryModalProps } from './WidgetLibraryModal';

export async function openWidgetLibrary(props: WidgetLibraryModalProps) {
  const { WidgetLibraryModal } = await import('./WidgetLibraryModal');

  openModal(WidgetLibraryModal, props);
}
